module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('scroller', {
    ref: "scrollerEvent",
    attrs: {
      "lock-x": "",
      "height": _vm.heightData,
      "scrollbarY": ""
    }
  }, [_c('div', {
    ref: "box",
    staticClass: "box"
  }, [(!_vm.isLoadMoreShow) ? _c('card', {
    staticClass: "movie-detail"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', [_vm._v("电影名：" + _vm._s(_vm.dataList.title) + " (" + _vm._s(_vm.dataList.year) + ")")]), _vm._v(" "), _c('h4', {
    staticClass: "head-style"
  }, [_vm._v("原名：" + _vm._s(_vm.dataList.original_title))]), _vm._v(" "), _c('h4', {
    staticClass: "head-style"
  }, [_vm._v("又名：" + _vm._s(_vm.dataList.aka))]), _vm._v(" "), _c('p', {
    staticClass: "head-style"
  }, [_vm._v("国家：" + _vm._s(_vm.dataList.countries))]), _vm._v(" "), _c('p', {
    staticClass: "head-style"
  }, [_vm._v("类型：" + _vm._s(_vm.dataList.genres))]), _vm._v(" "), _c('flexbox', {
    staticClass: "text-center"
  }, [_c('flexbox-item', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "flex-demo"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("想看")]), _vm._v(" "), _c('countup', {
    staticClass: "count",
    attrs: {
      "start-val": 0,
      "end-val": _vm.dataList.wish_count,
      "duration": 3
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "flex-demo"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("已看")]), _vm._v(" "), _c('countup', {
    staticClass: "count",
    attrs: {
      "start-val": 0,
      "end-val": _vm.dataList.collect_count,
      "duration": 3
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "up line"
  }, [_c('h3', [_vm._v("内容介绍")])]), _vm._v(" "), _c('div', {
    staticClass: "down"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "previewer-demo-img",
    attrs: {
      "src": _vm.dataList.images && _vm.dataList.images.medium
    },
    on: {
      "click": function($event) {
        _vm.show()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'hide-text': _vm.isTextHide
    },
    on: {
      "click": _vm.changeTextState
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t详情：" + _vm._s(_vm.dataList.summary) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.previewerList,
      "options": _vm.options
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "rating line"
  }, [_c('h3', [_vm._v("评分信息")]), _vm._v(" "), _c('div', {
    staticClass: "rating-style clearfix"
  }, [_c('span', [_vm._v("评价：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataList.average) + " / " + _vm._s(_vm.dataList.stars) + "分 / " + _vm._s(_vm.dataList.ratings_count) + "人")]), _vm._v(" "), _c('rater', {
    staticClass: "pr",
    attrs: {
      "value": _vm.dataList.star,
      "disabled": "",
      "star": "☻"
    }
  })], 1)]), _vm._v(" "), _c('cell', {
    staticClass: "info-source",
    attrs: {
      "title": "信息来源",
      "link": _vm.dataList.mobile_url
    }
  }), _vm._v(" "), (_vm.dataList.directors.length !== 0) ? _c('divider', {
    staticClass: "divider"
  }, [_vm._v("导演")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dataList.directors), function(item) {
    return _c('div', {
      key: item.id,
      on: {
        "click": function($event) {
          _vm.toRoute(item.id)
        }
      }
    }, [_c('masker', {
      staticClass: "masker",
      attrs: {
        "color": "F9C90C",
        "opacity": 0.5
      }
    }, [_c('div', {
      staticClass: "img-box",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('img', {
      attrs: {
        "src": item.avatars && item.avatars.small
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('p', [_vm._v("姓名：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])])])], 1)
  }), _vm._v(" "), (_vm.dataList.casts.length !== 0) ? _c('divider', {
    staticClass: "divider"
  }, [_vm._v("主演")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dataList.casts), function(item) {
    return _c('div', {
      key: item.id,
      on: {
        "click": function($event) {
          _vm.toRoute(item.id)
        }
      }
    }, [_c('masker', {
      staticClass: "masker",
      attrs: {
        "color": "09099C",
        "opacity": 0.5
      }
    }, [_c('div', {
      staticClass: "img-box",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('img', {
      attrs: {
        "src": item.avatars.small,
        "alt": "item.alt"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('p', [_vm._v("姓名：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])])])], 1)
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.isLoadMoreShow) ? _c('load-more', {
    attrs: {
      "tip": "loading"
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06880b82"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MovieDetail.vue
// module id = 185
// module chunks = 1